export class Transmission {
	identifiant: string | null;
	dateDepot: number;
	codeErreur: string | null;

	constructor(data?: { identifiant: string | null, dateDepot: number, errorCode: string | null }) {
		this.identifiant = data && data.identifiant || null;
		this.dateDepot = data && data.dateDepot || 0;
		this.codeErreur = data && data.errorCode || null;
	}
}

export interface TransmissionState {
	transmission?: Transmission;
	error: boolean;
	loaded: boolean;
}
